import React from 'react';
import PrivacyPolicy from '../components/PrivacyPolicy';

const AdminPrivacyPolicy = () => {
  return <PrivacyPolicy appType="admin" />;
};

export default AdminPrivacyPolicy;
